document.addEventListener('change', async event => {
  const box = event.target.closest('[data-cross-sell]');
  if (!box) return;

  box.disabled = true;
  const variantId = Number(box.value);
  const group = box.closest('[data-cross-sell-group]');
  const linked = group?.dataset.linkedQuantity === 'true' && !box.hasAttribute('data-single-cross-sell');
  const mainQuantity = Number(document.querySelector('[data-product-quantity]')?.value || 1);
  const desiredQuantity = linked ? mainQuantity : 1;
  const drawer = document.querySelector('cart-drawer');

  try {
    const cart = await fetch('/cart.js').then(response => response.json());
    const index = cart.items.findIndex(item => item.variant_id === variantId);

    if (box.checked) {
      if (index >= 0) {
        const response = await fetch('/cart/change.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({line: index + 1, quantity: desiredQuantity})
        });
        if (!response.ok) throw new Error();
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id: variantId, quantity: desiredQuantity}]})
        });
        if (!response.ok) throw new Error();
      }
      UltraDisco.push('select_cross_sell', {variant_id: variantId, quantity: desiredQuantity});
    } else if (index >= 0) {
      const response = await fetch('/cart/change.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({line: index + 1, quantity: 0})
      });
      if (!response.ok) throw new Error();
    }

    const updatedCart = await fetch('/cart.js').then(response => response.json());
    document.dispatchEvent(new CustomEvent('cart:updated', {detail: updatedCart}));
    await drawer?.refresh();
  } catch (error) {
    box.checked = !box.checked;
    document.querySelector('#CartStatus').textContent = 'Operazione non riuscita. Riprova.';
  } finally {
    box.disabled = false;
  }
});
